import classNames from "classnames/bind";
import parse from "html-react-parser";

import styles from "./IconUl.module.scss";

const cx = classNames.bind(styles);

type IconUlProps = {
    listHtml: string;
};

const IconUl = ({ listHtml }: IconUlProps) => {
    const parsedHtml = parse(listHtml);

    return <div className={cx("list", "iconList")}>{parsedHtml}</div>;
};

export default IconUl;
